<template>
  <el-dialog
    :title="$t('langcfg.txtMapDisplaySettings')"
    :visible.sync="visible"
    width="32%"
    top="8vh"
  >
    <div style="display: flex; flex-direction: column">
      <div
        v-for="(item, key) in mapDrawSettings[parentForm]['mapInForm' + indexInForm]['shapes']"
        :class="`map-draw-content ${key}`"
        :key="key"
        :ref="key"
      >
        <IconShape :size="37" :iconType="key" />
        <!-- <el-checkbox
          :label="$t(`langcfg.txt${key}`)"
          v-model="$store.state.mapDrawSettings[parentForm]['mapInForm' + indexInForm]['shapes'][key]"
        ></el-checkbox>-->
        <div
          style="display: flex; flex-direction: row; align-items: center"
          @click="changeMapDrawSettings(key)"
        >
          <input type="checkbox" :ref="`ck_${key}`" :checked="checked[key]" class="checkbox-item" />
          <span style="font-size: 25px; line-height: 25px"
            >&nbsp;&nbsp;{{ $t(`langcfg.txt${key}`) }}</span
          >
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="hideDialog" class="btn-oprator">{{ $t("langcfg.txtOK") }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { isDefined, NORMALMAPSTYLES } from "../../shared/index";
import IconShape from "../../components/IconShape";
export default {
  name: "MapDrawSettings",
  data() {
    return {
      visible: false,
      order: 8,
      diameter: 4,
      formLabelWidth: "100px",
      index: 0
    };
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    isDiff: {
      type: Boolean,
      default: false
    },
    isZernike: {
      type: Boolean,
      default: false
    },
    eyeType: {
      type: String,
      default: "OS"
    },
    mapStyle: {
      type: String,
      default: NORMALMAPSTYLES[0]
    },
    parentForm: {
      type: String,
      default: "largemap"
    },
    indexInForm: {
      type: Number,
      default: 0
    }
  },
  watch: {
    isVisible: function (val) {
      this.visible = val;
    },
    visible: function (val) {
      this.initLayout();
      if (!val) {
        this.$emit("update:isVisible", false);
      }
    }
  },
  components: {
    IconShape
  },
  mounted() {
    if (
      this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
        "ShowDiameter9mm"
      ]
    ) {
      if (
        isDefined(
          this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
            "ShowNinemmBorder"
          ]
        )
      ) {
        this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
          "ShowNinemmBorder"
        ] = false;
      }
    }
    if (
      this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
        "ShowNinemmBorder"
      ]
    ) {
      if (
        isDefined(
          this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
            "ShowDiameter9mm"
          ]
        )
      ) {
        this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
          "ShowDiameter9mm"
        ] = false;
      }
    }
  },
  computed: {
    ...mapGetters(["mapDrawSettings"]),
    checked() {
      return this.mapDrawSettings[this.parentForm][`mapInForm${this.indexInForm}`]["shapes"];
    }
  },
  methods: {
    ...mapActions({
      mapDrawSettingsChanged: "topography/mapDrawSettingsChanged"
    }),
    changeMapDrawSettings(key) {
      this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][key] =
        !this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][key];
      if (key === "ShowNumericValues") {
        if (
          this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
            "ShowNumericValues"
          ]
        ) {
          if (
            isDefined(
              this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
                "ShowMaxMin"
              ]
            )
          ) {
            this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
              "ShowMaxMin"
            ] = false;
          }
        }
      }
      if (key === "ShowMaxMin") {
        if (
          this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
            "ShowMaxMin"
          ]
        ) {
          if (
            isDefined(
              this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
                "ShowNumericValues"
              ]
            )
          ) {
            this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
              "ShowNumericValues"
            ] = false;
          }
        }
      }
      if (key === "ShowNinemmBorder") {
        if (
          this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
            "ShowNinemmBorder"
          ]
        ) {
          if (
            isDefined(
              this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
                "ShowDiameter9mm"
              ]
            )
          ) {
            this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
              "ShowDiameter9mm"
            ] = false;
          }
        }
      }
      if (key === "ShowDiameter9mm") {
        if (
          this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
            "ShowDiameter9mm"
          ]
        ) {
          if (
            isDefined(
              this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
                "ShowNinemmBorder"
              ]
            )
          ) {
            this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
              "ShowNinemmBorder"
            ] = false;
          }
        }
      }
      this.mapDrawSettingsChanged(this.mapDrawSettings);
    },
    initLayout() {
      this.$nextTick(() => {
        if (isDefined(this.$refs["ShowAlpha"])) {
          this.$refs["ShowAlpha"][0].style.display = "none";
        }
        if (isDefined(this.$refs["ShowMaxPeak"])) {
          this.$refs["ShowMaxPeak"][0].style.display = "none";
        }

        switch (this.parentForm) {
          case "zernike":
            [
              "ShowEyeType",
              "ShowNinemmBorder",
              "ShowDiameter9mm",
              "ShowMaxMin",
              "ShowMinRadiusF",
              "Show3579Ring"
            ].forEach((item) => {
              if (isDefined(this.$refs[item])) {
                this.$refs[item][0].style.display = "none";
                this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
                  item
                ] = false;
              }
            });
            if (isDefined(this.$refs["ShowMaxPeak"])) {
              this.$refs["ShowMaxPeak"][0].style.display = "flex";
            }
            break;
          case "contectlens":
            ["ShowNinemmBorder", "ShowDiameter9mm", "ShowApexPosition"].forEach((item) => {
              if (isDefined(this.$refs[item])) {
                this.$refs[item][0].style.display = "none";
              }
            });
            break;
          case "compare2records":
            if (this.isDiff) {
              [
                "ShowEyeType",
                "ShowNinemmBorder",
                "ShowMaxPeak",
                "ShowAlpha",
                "ShowMaxMin",
                "ShowMinRadiusF",
                "Show3579Ring",
                "ShowApexPosition",
                "ShowMaxMin",
                "ShowNasalTemp"
              ].forEach((item) => {
                if (isDefined(this.$refs[item])) {
                  this.$refs[item][0].style.display = "none";
                  this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
                    item
                  ] = false;
                }
              });
            }
            break;
          default:
            break;
        }

        if (!this.$refs["ShowMaxMin"] || this.isDiff) return;

        switch (this.mapStyle) {
          case NORMALMAPSTYLES[0]:
            this.$refs["ShowMaxMin"][0].style.display = "flex";
            break;
          case NORMALMAPSTYLES[1]:
            this.$refs["ShowMaxMin"][0].style.display = "flex";
            break;
          case NORMALMAPSTYLES[2]:
          case NORMALMAPSTYLES[3]:
          case NORMALMAPSTYLES[4]:
          case NORMALMAPSTYLES[5]:
            if (isDefined(this.$refs["ShowMaxMin"])) {
              this.$refs["ShowMaxMin"][0].style.display = "none";
              this.mapDrawSettings[this.parentForm]["mapInForm" + this.indexInForm]["shapes"][
                "ShowMaxMin"
              ] = false;
            }
            break;
          default:
            break;
        }
      });
    },
    hideDialog() {
      this.visible = false;
      this.mapDrawSettingsChanged(this.mapDrawSettings);
    }
  }
};
</script>
<style lang="less" scoped>
.el-checkbox {
  margin: 0px;
  text-align: left;
}
.el-checkbox /deep/ .el-checkbox__label {
  color: white;
  font-size: 25px;
}
.el-checkbox /deep/ .el-checkbox__inner {
  width: 24px;
  height: 24px;
}

.el-checkbox /deep/ .el-checkbox__inner::after {
  height: 17px;
  width: 12px;
}
.el-checkbox /deep/ .el-checkbox__input {
  vertical-align: middle;
}
.btn-oprator {
  border: 1px gray solid;
  height: @header-fs+50px;
  width: 200px;
  font-size: 30px;
}
.btn-oprator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-oprator:active {
  background: @btn-active-color;
}
.map-draw-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 30px;
}
.checkbox-item {
  line-height: 25px;
  padding: 0px;
  border: none;
  width: 25px;
  height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/topography/pages/dialog-forms/MapDrawSettings.vue